export default __webpack_public_path__ + "static/media/texture3.e056ce7f.png";